import React from 'react';

import { Outlet } from '@tanstack/react-router';

import { FullPageLoadingSpinner } from '@components/spinners';
import { AlertContainer, NetworkStatusChecker } from '@components/ui';
import * as constant from '@constants';

import { CookiesChecker } from '../CookiesChecker';
import { ExternalServices } from '../ExternalServices';
import { ThemeManager } from '../ThemeManager';

import { DevelopmentTools } from './DevelopmentTools';

export const RootComponent: React.FC = () => {
  const isProduction = ['production', 'staging'].includes(import.meta.env.MODE);

  return (
    <ThemeManager>
      <ExternalServices />
      <NetworkStatusChecker />
      <AlertContainer
        autoClose={constant.TOAST_TIMER}
        pauseOnFocusLoss
        limit={constant.MAX_TOASTS_ON_PAGE}
        hideProgressBar
      />
      <CookiesChecker />
      <React.Suspense fallback={<FullPageLoadingSpinner backdrop={false} />}>
        <Outlet />
      </React.Suspense>
      {isProduction ? undefined : <DevelopmentTools />}
    </ThemeManager>
  );
};
